export const queries = {
	title: {
		interpretation: { vocab: "snomed", code: "184098006" }
	},
	firstName: {
		interpretation: { vocab: "snomed", code: "184095009" }
	},
	lastName: {
		interpretation: { vocab: "snomed", code: "184096005" }
	},
	dateOfBirth: {
		interpretation: { vocab: "snomed", code: "184099003" }
	}
};
